export const headCopy = {
  head_playground_title:
    "Playground - Un editor en linea para explorar TypeScript y JavaScript",
  head_playground_description:
    "El editor te permite escribir código TypeScript o JavaScript en linea de manera segura y compartida.",
  tsconfig_title:
    "Referencia TSConfig - Documentación sobre todas las opciones de configuración en TSConfig",
  tsconfig_description:
    "Desde la opción allowJs a useDefineForClassFields, las referencias de TSConfig incluyen información sobre todas las configuraciones activas del compilador en un proyecto TypeScript.",
  playground_example_prefix: "Playground Example - ",

  head_index_title: "JavaScript Escalable",
  head_index_description: "JavaScript Escalable",
}
